/** 自定义壁纸下页面卡片表面实色占比（0 全透明，100 全实色） */

/** 与 windowOpacity 一致；勿用 @/ 别名，避免子应用打包 globalStore 时解析失败 */
const clampWindowBackgroundAlpha = (value: number) =>
  Math.min(1, Math.max(0.1, value));

export const WALLPAPER_COMPONENT_BG_TRANSPARENCY_VAR =
  "--wallpaper-component-bg-transparency";

export const WALLPAPER_COMPONENT_SURFACE_SOLID_RATIO_VAR =
  "--wallpaper-component-surface-solid-ratio";

export const WALLPAPER_SURFACE_MIX_ATTR = "data-wallpaper-surface-mix";

/** 历史壁纸模式默认表面实色占比（25%） */
export const LEGACY_WALLPAPER_SURFACE_SOLID_PERCENT = 25;

export const clampComponentSurfaceBgTransparency = (value: number) =>
  Math.min(100, Math.max(0, Math.round(value)));

/** 渲染用：仅 100 为全实色；0 为全透明 */
export const normalizeComponentBgTransparencyForRender = (value: number) => {
  const clamped = clampComponentSurfaceBgTransparency(value);
  if (clamped >= 100) return 100;
  return clamped;
};

/** 选择壁纸时：将原 25%×窗口透明度 映射为滑块值（实色占比 %） */
export const computeWallpaperComponentBgTransparency = (
  windowBackgroundAlpha = 1
): number => {
  const alpha = clampWindowBackgroundAlpha(windowBackgroundAlpha);
  const solidPercent = LEGACY_WALLPAPER_SURFACE_SOLID_PERCENT * alpha;
  return clampComponentSurfaceBgTransparency(solidPercent);
};

export const applyComponentSurfaceBgTransparency = (
  transparency: number,
  active: boolean
): void => {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  if (!active) {
    root.style.removeProperty(WALLPAPER_COMPONENT_BG_TRANSPARENCY_VAR);
    root.style.removeProperty(WALLPAPER_COMPONENT_SURFACE_SOLID_RATIO_VAR);
    root.removeAttribute(WALLPAPER_SURFACE_MIX_ATTR);
    return;
  }

  const renderValue = normalizeComponentBgTransparencyForRender(transparency);
  const solidRatio = renderValue / 100;

  root.style.setProperty(
    WALLPAPER_COMPONENT_SURFACE_SOLID_RATIO_VAR,
    String(solidRatio)
  );
  root.style.setProperty(
    WALLPAPER_COMPONENT_BG_TRANSPARENCY_VAR,
    String(renderValue)
  );

  if (renderValue >= 100) {
    root.removeAttribute(WALLPAPER_SURFACE_MIX_ATTR);
    return;
  }

  root.setAttribute(WALLPAPER_SURFACE_MIX_ATTR, "true");
};
